<ion-button
  [mode]="
    windowDimensions && windowDimensions.width && windowDimensions.width <= 350
      ? 'ios'
      : ''
  "
  [class]="
    showButton && !firstTime
      ? 'animate__animated animate__pulse'
      : showButton && firstTime
      ? 'animate__animated animate__backInUp'
      : !showButton
      ? 'animate__animated animate__fadeOutDownBig'
      : ''
  "
  size="small"
  style="
    position: absolute;
    bottom: 20px;
    left: 8px;
    z-index: 100;
    min-width: 200px;
    min-height: 35px;
  "
  (click)="navigateCart()"
>
  <ion-text>
    {{ "cart.cart-components.cart-list.checkout" | translate }}
    {{
      cartPrices && cartPrices.grand_total
        ? (cartPrices.grand_total
            | priceWithComma: store_info && store_info.showPricesWithComma) + "€"
        : ""
    }}
  </ion-text>
</ion-button>
